export default {
   seconds: (s: number): Promise<void> => new Promise(resolve => window.setTimeout(resolve, s * 1000))
};